import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  CircularProgress,
  Button,
  Box,
  Chip,
  Stack
} from "@mui/material";
import SchoolIcon from '@mui/icons-material/School';
import AutoModeIcon from '@mui/icons-material/AutoMode';

function CategoryGrid({ onCategoryChange }) {
  const [uuidMapping, setUuidMapping] = useState([]);
  const [loading, setLoading] = useState(true);
  const [quizProgress, setQuizProgress] = useState({});
  const [questionCounts, setQuestionCounts] = useState({});
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubcategory, setActiveSubcategory] = useState(null);

  useEffect(() => {
    fetch("./vragen/uuid-mapping.json")
      .then((res) => res.json())
      .then((data) => {
        // Flatten de JSON mapping array
        const mapping = Array.isArray(data) ? data.reduce((acc, item) => {
          const [uuid, details] = Object.entries(item)[0];
          acc[uuid] = details;
          return acc;
        }, {}) : {};

        setUuidMapping(mapping);
        console.log(mapping);
        // Haal voortgang op uit localStorage
        const storedProgress = JSON.parse(localStorage.getItem("quizProgress")) || {};
        setQuizProgress(storedProgress);

        // Controleer of bestanden bestaan en haal vraaggegevens op
        const fileChecks = Object.keys(mapping).map((uuid) =>
          fetch(`./vragen/${uuid}.json`)
            .then((res) => (res.ok ? res.json() : null))
                .then((questionsData) => (questionsData && Array.isArray(questionsData.vragen) ? { uuid, count: questionsData.vragen.length } : null))

        );

        Promise.all(fileChecks).then((results) => {
          const countsMap = results.reduce((acc, item) => {
            if (item) {
              acc[item.uuid] = item.count;
            }
            return acc;
          }, {});
          setQuestionCounts(countsMap);
          setLoading(false);
        });
      })
      .catch((error) => {
        console.error("Fout bij het laden van de mapping:", error);
        setLoading(false);
      });
  }, []);

  const handleCategoryFilter = (category) => {
    setActiveCategory(category === activeCategory ? null : category);
    setActiveSubcategory(null);
  };

  const handleSubcategoryFilter = (subcategory) => {
    setActiveSubcategory(subcategory === activeSubcategory ? null : subcategory);
  };

  const resetFilters = () => {
    setActiveCategory(null);
    setActiveSubcategory(null);
  };

  if (loading) {
    return (
      <Grid container justifyContent="center" alignItems="center" style={{ minHeight: "300px" }}>
        <CircularProgress />
      </Grid>
    );
  }

  const filteredMapping = Object.keys(uuidMapping).filter((uuid) => {
    if (!questionCounts[uuid]) return false; // Filter UUID's zonder corresponderend bestand
    const { CAT, SUBCAT } = uuidMapping[uuid];
    if (activeCategory && CAT !== activeCategory) return false;
    if (activeSubcategory && SUBCAT !== activeSubcategory) return false;
    return true;
  });

  const categories = [...new Set(Object.values(uuidMapping).map((item) => item.CAT))];
  const subcategories = [...new Set(Object.values(uuidMapping).map((item) => item.SUBCAT))];

  return (
    <Box>
      <Box display="flex" justifyContent="center" mb={2} flexWrap="wrap">
        <Button variant="contained" onClick={resetFilters} style={{ margin: "5px" }}>
          Alle
        </Button>
        {categories.map((category) => (
          <Button
            key={category}
            variant={activeCategory === category ? "contained" : "outlined"}
            onClick={() => handleCategoryFilter(category)}
            style={{ margin: "5px" }}
          >
            {category}
          </Button>
        ))}
      </Box>
     

      <Grid container spacing={3}>
        {filteredMapping.map((uuid) => {
          const { CAT, SUBCAT, VRAAG_TITLE } = uuidMapping[uuid];
          const progress = quizProgress[uuid] || {};
          const totalQuestions = questionCounts[uuid] || 0;
          const answeredQuestions = progress.answers ? Object.keys(progress.answers).length : 0;
          const correctAnswers = Object.values(progress.answers || {}).filter(
            (entry) => entry.isCorrect
          ).length;

          let backgroundColor = "white";
          let statusText = "Nog niet gestart";

          if (answeredQuestions > 0 && answeredQuestions < totalQuestions) {
            backgroundColor = "lightblue";
            statusText = `Beantwoord: ${answeredQuestions}/${totalQuestions}`;
          } else if (answeredQuestions === totalQuestions) {
            backgroundColor = correctAnswers / totalQuestions >= 0.5 ? "lightgreen" : "lightcoral";
            statusText = `Score: ${correctAnswers}/${totalQuestions}`;
          }

          return (
            <Grid item xs={12} sm={6} md={3} key={uuid}>
              <Card style={{ height: "100%", backgroundColor }}>
                <CardActionArea onClick={() => onCategoryChange(uuid)}>
                  <CardContent>
                  <Stack direction="column" spacing={1}>
                      <Chip label={`${CAT}`}  size="small" />
                      <Chip label={`${SUBCAT}`}  size="small" />
                    </Stack>
                    <Stack direction="column" spacing={1} mt={2}>
                       <Chip icon={<SchoolIcon />} label={`${totalQuestions} vragen`}  />

                    </Stack>
                    <Box mt={2} p={1} bgcolor="white" textAlign={"center"}>
                    <Typography variant="body2" gutterBottom>
                        {statusText}
                    </Typography>
                    </Box>
                   
                   
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

export default CategoryGrid;
